(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grid-banner"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  $(".video__btn-play").on("click", function (e) {
    e.preventDefault();
    $('body').addClass('overlay-active');
    $(".video-popup").css('display','flex');
    var srchref = "",
        autoplay = "",
        id = $(this).data("id");
    if ($(this).data("type") == "vimeo")
      var srchref = "//player.vimeo.com/video/";
    else if ($(this).data("type") == "youtube")
      var srchref = "https://www.youtube.com/embed/";
    if ($(this).data("autoplay") == true) autoplay = "?autoplay=1";
    $("#video-popup-iframe").attr("src", srchref + id + autoplay);
    $("#video-popup-iframe").on("load", function () {
      $(".video-wrapper").show();
    });
  });

  $(".pop-up__video-close , .video-popup").on("click", function (e) {
     $('body').removeClass('overlay-active');
    $(".video-container,.video-wrapper,.pop-up__video-close ,.video-popup").css('display','none');
    $("#video-popup-iframe").attr("src", "");
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grid-tab"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  var autoPlayTimer = null;

  function startVideo($container) {
    var $btn = $container.find(".video__btn-play");
    if (!$btn.length) return;

    var $img = $container.find("img.grid-banner-image");
    var $inlineWrapper = $container.find(".grid-inline-video-wrapper");
    var mp4Url = $btn.data("mp4");
    var type = $btn.data("type");
    var id = $btn.data("id");

    if ($img.length) {
      var maskImg = $img.css("-webkit-mask-image") || $img.css("mask-image");
      var maskSz = $img.css("-webkit-mask-size") || $img.css("mask-size");
      var maskPos = $img.css("-webkit-mask-position") || $img.css("mask-position");
      var maskRep = $img.css("-webkit-mask-repeat") || $img.css("mask-repeat");
      var rad = $img.css("border-radius");

      if (maskImg && maskImg !== "none") {
        $inlineWrapper.css({
          "-webkit-mask-image": maskImg,
          "mask-image": maskImg,
          "-webkit-mask-size": maskSz,
          "mask-size": maskSz,
          "-webkit-mask-position": maskPos,
          "mask-position": maskPos,
          "-webkit-mask-repeat": maskRep,
          "mask-repeat": maskRep
        });
      }
      if (rad) {
        $inlineWrapper.css("border-radius", rad);
      }
    }

    if (mp4Url && String(mp4Url).trim() !== "") {
      var $video = $(
        '<video autoplay loop muted playsinline disablePictureInPicture controlsList="nofullscreen nodownload noremoteplayback" style="width:100% !important; height:100% !important; object-fit:cover !important; border-radius:inherit;"><source src="' + mp4Url + '" type="video/mp4"></video>'
      );

      $video.on("playing", function () {
        $container.addClass("video-rendered");
      });

      $inlineWrapper.html($video);
    } else {
      var src = "";
      if (type === "vimeo") {
        src = "https://player.vimeo.com/video/" + id + "?autoplay=1&muted=1&loop=1&controls=0";
      } else {
        src = "https://www.youtube.com/embed/" + id + "?autoplay=1&mute=1&loop=1&playlist=" + id + "&controls=0&disablekb=1&fs=0&modestbranding=1&rel=0&playsinline=1&enablejsapi=1";
      }

      var $iframe = $(
        '<iframe src="' + src + '" allow="autoplay; encrypted-media" style="width:100% !important; height:100% !important; border:none; border-radius:inherit; pointer-events:none;"></iframe>'
      );

      $iframe.on("load", function () {
        setTimeout(function () {
          $container.addClass("video-rendered");
        }, 300);
      });

      $inlineWrapper.html($iframe);
    }

    $container.addClass("is-playing");
  }

  function triggerActiveTabVideo() {
    clearTimeout(autoPlayTimer);

    var $activeContainer = $(".dt-sc-tabs-content-Details.active .grid-banner-block-image");
    if ($activeContainer.length && $activeContainer.find(".video__btn-play").length) {
      autoPlayTimer = setTimeout(function () {
        startVideo($activeContainer);
      }, 1000);
    }
  }

  triggerActiveTabVideo();

  $(document).on("click", ".grid-sound-toggle-btn", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $container = $(this).closest(".grid-banner-block-image");
    var video = $container.find("video").get(0);
    var $btn = $(this);

    if (video) {
      video.muted = !video.muted;
      if (video.muted) {
        $btn.find(".icon-sound-muted").show();
        $btn.find(".icon-sound-unmuted").hide();
      } else {
        $btn.find(".icon-sound-muted").hide();
        $btn.find(".icon-sound-unmuted").show();
      }
    }
  });

  $(".tablinks").on("click", function () {
    clearTimeout(autoPlayTimer);

    $(".grid-banner-block-image.is-playing")
      .removeClass("is-playing video-rendered")
      .find(".grid-inline-video-wrapper")
      .empty()
      .hide();

    $(".grid-sound-toggle-btn .icon-sound-muted").show();
    $(".grid-sound-toggle-btn .icon-sound-unmuted").hide();

    setTimeout(function () {
      triggerActiveTabVideo();
    }, 50);
  });

  var sectionElements = document.querySelectorAll(".grid-video-product-tab");
  if ("IntersectionObserver" in window) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var $section = $(entry.target);
        var videos = $section.find(".grid-banner-block-image.is-playing video");
        var iframes = $section.find(".grid-banner-block-image.is-playing iframe");

        if (entry.isIntersecting) {
          videos.each(function () {
            this.play();
          });
          iframes.each(function () {
            this.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          });
        } else {
          videos.each(function () {
            this.pause();
          });
          iframes.each(function () {
            this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          });
        }
      });
    }, { threshold: 0.15 });

    sectionElements.forEach(function (sec) {
      videoObserver.observe(sec);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
